import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { I_competition_entry } from '../models/i_competition_entry.interface';
import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class PendingCompetitionEntryService {

  constructor(private http: HttpClient) { }

  create(competition_entry: I_competition_entry): Promise<I_competition_entry> {
  	let post_data = {};

  	if(competition_entry.is_section_entry){
  		post_data = {
        data: {
          type: 'section_entry',
          attributes: { section_entry: competition_entry }
          }
      };
  	} else {
  		post_data = {
        data: {
          type: 'competition_entry',
          attributes: { competition_entry: competition_entry }
          }
      };
  	}

    return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'pending_competition_entries',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && (response.type=='competition_entry' || response.type=='section_entry')) {
                       	resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
   }

  delete(competition_entry: I_competition_entry): Promise<boolean> {

    let url_segment: string = "";

    if(competition_entry.is_section_entry){
      url_segment = "section_id/" + competition_entry.section_id + "/entry_id/" + competition_entry.entry_id;
      } else {
       url_segment = "id/" + competition_entry.id;
      }


    return new Promise((resolve, reject) => {

      return this.http.delete(AppSettings.API_ENDPOINT + 'pending_competition_entries/' + url_segment,  AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
           if(response.data && (response.type=='competition_entry_delete_response' || response.type=='section_entry_delete_response')) {
               resolve(response.data);
             }  else {
               reject(response);
             }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

}
